<template>
  <div class="LmDetailComments">
    <lm-title class="mb-8">{{ title }}</lm-title>
    <ul>
      <lm-detail-comment
        v-for="(comment, index) in currentItem.comments"
        :id="'comment' + (index + 1)"
        :ref="'comment-' + comment._id"
        :key="comment._id"
        :admin-rights="hasAdminRights"
        :content="comment"
        :new-comment="isNewComment(index + 1)"
        @vote="onCommentVote"
        @optionSelected="onOptionSelected"
      />
    </ul>
    <lm-comment-box :section="section" @comment-added="onCommentAdded" />
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import {Events} from '@/lib/definitions'
import EventHub from '@/lib/eventHub'
import LmCommentBox from '@/components/ui/detail/LmCommentBox'
import LmTitle from '@/components/ui/text/LmTitle'
import LmDetailComment from '@/components/ui/detail/LmDetailComment'

export default {
  name: 'LmDetailComments',
  components: {LmCommentBox, LmDetailComment, LmTitle},
  props: {
    currentItem: {
      type: Object,
      required: true
    },
    section: {
      type: String,
      required: true
    }
  },
  data() {
    return {}
  },
  computed: {
    ...mapGetters(['getUserByID', 'hasAdminRights']),
    title() {
      const n = this.currentItem.commentCount
      return n + ' ' + this.$options.filters.pluralizeWord('Comment', n)
    }
  },
  watch: {
    currentItem() {
      if (this.$route.query && this.$route.query.c)
        this.scrollTo(this.$route.query.c)
    }
  },
  mounted() {
    if (this.$route.query && this.$route.query.c)
      this.scrollTo(this.$route.query.c)
  },
  methods: {
    scrollTo(commentId) {
      setTimeout(() => {
        const commentRef = this.$refs['comment-' + commentId]
        if (!commentRef) return
        const comment = commentRef[0]
        const selector = comment.$el
        selector.scrollIntoView({behavior: 'smooth'})
        comment.highlight()
      }, 500)
    },
    onCommentAdded() {
      const id = this.currentItem.comments[this.currentItem.comments.length - 1]
        ._id
      const comment = this.$refs['comment-' + id][0]
      comment.highlight()
    },
    isNewComment(index) {
      const unreadComments = this.currentItem.currentUser.unreadComments
      if (unreadComments === 0) {
        return false
      } else {
        const position = this.currentItem.commentCount - unreadComments
        return index > position
      }
    },
    onOptionSelected(item, commentId) {
      switch (item.action) {
        case 'edit':
          this.editComment(commentId)
          break
        case 'delete':
          this.deleteComment(commentId)
          break
      }
    },
    editComment(commentId) {
      this.$emit('edit', commentId)
    },
    deleteComment(commentId) {
      let params = {
        entity: 'comment',
        prompt: 'Are you sure you want to delete this comment?'
      }
      EventHub.emit(
        Events.OPEN_CONFIRM,
        params,
        this.doDeleteComment,
        false,
        commentId
      )
    },
    doDeleteComment(commentId) {
      this.$emit('delete', commentId)
    },
    onCommentVote(vote, commentId) {
      this.$emit('vote', {
        vote,
        commentId
      })
    }
  }
}
</script>
